import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { CartPreviewItem } from 'projects/shared/lib/components/shared/cart/preview/item/cart-preview-item.model';

/**
 * Pipe regarding filtering of cart items. Valid items will be returned.
 * requires an import in the decorator.
 * usage only inside the html template. NO TS CODE.
 * for ts code useage @see CartItemFilterValidService
 */
@Pipe({
  name: 'cartItemFilterValid',
  standalone: true,
  pure: false
})
export class CartItemFilterValidPipe implements PipeTransform {

  public transform(cartItemList: CartPreviewItem[]): CartPreviewItem[] {
    return CartItemFilterValidService.transform(cartItemList);
  }

}

/**
 * Pipe regarding filtering of cart items. Valid items will be returned.
 * no import required.
 * no instance required.
 * usage only inside the ts code. NO HTML TEMPLATE.
 * for html template usage @see CartItemFilterValidPipe
 */
@Injectable({
  providedIn: 'root'
})
export class CartItemFilterValidService {

  public static transform(cartItemList: CartPreviewItem[]): CartPreviewItem[] {
    return cartItemList.filter(i => i.validationResult == undefined);
  }

}
